<template>
  <svg
    class="p-mochi"
    :width="size"
    :height="size * 1.2"
    viewBox="0 0 200 240"
    fill="none"
    aria-hidden="true"
  >
    <!-- Body — squishy puff -->
    <path
      d="M100 90
         C 55 90, 30 115, 32 150
         C 34 195, 62 218, 100 218
         C 138 218, 166 195, 168 150
         C 170 115, 145 90, 100 90 Z"
      fill="#FFFFFF"
      stroke="#E6DCC4"
      stroke-width="2"
    />
    <!-- Little tuft on top -->
    <path
      d="M95 90 Q100 78 105 90"
      fill="none"
      stroke="#C9C0B2"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <!-- Soft underside shadow -->
    <ellipse cx="100" cy="200" rx="60" ry="12" fill="#F0E8D2" opacity="0.5" />

    <!-- Face — sleepy expression by default (eyes are horizontal lines) -->
    <!-- Anchors: ex1=86, ex2=114, ey=138, mx=100, my=152 -->
    <g v-if="expr === 'sleepy'">
      <g fill="none" stroke="#1F1A14" stroke-width="3" stroke-linecap="round">
        <line x1="81" y1="138" x2="91" y2="138" />
        <line x1="109" y1="138" x2="119" y2="138" />
      </g>
      <path d="M96 152 Q100 155 104 152" fill="none" stroke="#1F1A14" stroke-width="2.4" stroke-linecap="round" />
    </g>

    <!-- happy expression — closed arc eyes + soft smile -->
    <g v-else-if="expr === 'happy'">
      <g fill="none" stroke="#1F1A14" stroke-width="3.2" stroke-linecap="round">
        <path d="M81 139 Q86 133 91 139" />
        <path d="M109 139 Q114 133 119 139" />
      </g>
      <path d="M94 151 Q100 157 106 151" fill="none" stroke="#1F1A14" stroke-width="2.6" stroke-linecap="round" />
    </g>

    <!-- default expression — open eyes + smile -->
    <g v-else>
      <g fill="#1F1A14">
        <ellipse cx="86" cy="138" rx="2.6" ry="3.4" />
        <ellipse cx="114" cy="138" rx="2.6" ry="3.4" />
      </g>
      <path d="M94 151 Q100 157 106 151" fill="none" stroke="#1F1A14" stroke-width="2.6" stroke-linecap="round" />
    </g>

    <!-- Blush -->
    <g v-if="blush" fill="#F5B5A8" opacity="0.7">
      <ellipse cx="84" cy="147" rx="6" ry="3.5" />
      <ellipse cx="116" cy="147" rx="6" ry="3.5" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MochiCharacter',
  props: {
    size: { type: [String, Number], default: 160 },
    expr: {
      type: String,
      default: 'sleepy',
      validator: (v) => ['default', 'sleepy', 'happy'].includes(v),
    },
    blush: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.p-mochi {
  display: block;
  filter: drop-shadow(0 6px 14px rgba(31, 27, 20, 0.12));
}
</style>
